
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import FeaturedProperties from './components/FeaturedProperties';
import ConstructionProjects from './components/ConstructionProjects';
import ContactForm from './components/ContactForm';
import Footer from '../../components/feature/Footer';
import Navigation from '../../components/feature/Navigation';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <About />
      <Services />
      <FeaturedProperties />
      <ConstructionProjects />
      <ContactForm />
      <Footer />
    </div>
  );
}
